<template>
    <d-container fluid class="main-content-container px-4 pb-2 background">
        <div class="container">
            <div class="d-flex justify-content-center h-50">
                <div class="user_card">
                    <div class="d-flex justify-content-center">
                        <div class="d-flex justify-content-center mt-3 login_container">
                            <h2 class="mt-4">SERVI99</h2>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center form_container">
                        <form @submit.prevent="Login()">
                            <div class="input-group mb-3">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                                </div>
                                <input required type="text" name="user" id="user" v-model="user"
                                    class="form-control input_user" placeholder="Usuario" />
                            </div>
                            <div class="input-group mb-2">
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input required type="password" v-model="password" id="password" name="password"
                                    class="form-control input_pass" placeholder="Contraseña" />
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-checkbox"></div>
                            </div>
                            <div class="d-flex justify-content-center mt-3 login_container">
                                <button type="submit" name="submit" value="Iniciar Sesión" class="btn login_btn">
                                    Iniciar sesión
                                </button>
                            </div>
                            <div class="text-center">
                                <span style="font-size: 10px !important">{{ version }}</span>
                            </div>
                            <div class="d-flex justify-content-center mt-1 login_container">
                                <span style="font-size: 8px">V 24112025</span>
                            </div>
                            <div class="d-flex justify-content-center mt-1 login_container" v-if="distancia !== ''">
                                <span style="font-size: 8px">{{ distancia.toFixed(2) + ' km' }}</span>
                            </div>
                            <br />
                        </form>
                    </div>
                    <div class="mt-4"></div>
                </div>
            </div>
        </div>
    </d-container>
</template>

<script>
import api from "../config/api";

// Función para calcular distancia (Haversine)
async function calcularDistancia(lat1, lon1, lat2, lon2) {
    return new Promise((resolve, reject) => {
        const lat1Num = parseFloat(lat1);
        const lon1Num = parseFloat(lon1);
        const lat2Num = parseFloat(lat2);
        const lon2Num = parseFloat(lon2);

        if (isNaN(lat1Num) || isNaN(lon1Num) || isNaN(lat2Num) || isNaN(lon2Num)) {
            reject(new Error("Coordenadas inválidas"));
        }

        const R = 6371; // Radio de la Tierra en km
        const dLat = (lat2Num - lat1Num) * Math.PI / 180;
        const dLon = (lon2Num - lon1Num) * Math.PI / 180;
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1Num * Math.PI / 180) *
            Math.cos(lat2Num * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distancia = R * c;
        resolve(distancia);
    });
}

export default {
    data() {
        return {
            user: "",
            password: "",
            version: "",
            misCoordenadas: "",
            distancia: ""
        };
    },
    mounted() {
        this.misCoordenadas = "";
        this.version = localStorage.getItem("version") || "";
    },
    methods: {
        async checkpermisoUbicacion() {
            if (!navigator.geolocation) {
                alert("Tu navegador no soporta geolocalización.");
                return false;
            }

            // Intentar usar Permissions API para detectar estado sin molestar al usuario
            try {
                if (navigator.permissions && navigator.permissions.query) {
                    const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
                    if (permissionStatus.state === "denied") {
                        // 👇 Este alert ya existe y NO se modifica
                        this.$swal("Has bloqueado los permisos de ubicación. Por favor habilítalos en la configuración de tu navegador.");
                        return false;
                    }
                    // Si es "granted" o "prompt", seguimos adelante
                }
                // Si Permissions API no está disponible, igual intentamos obtener posición
            } catch (err) {
                console.warn("No se pudo consultar Permissions API, procediendo directamente...", err);
                // No bloqueamos; dejamos que getCurrentPosition maneje el permiso
            }

            // Pedir ubicación (esto mostrará el diálogo nativo del navegador si el permiso no está decidido)
            return new Promise((resolve) => {
                const options = {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                };

                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        this.misCoordenadas = `${position.coords.latitude}, ${position.coords.longitude}`;
                        resolve(true);
                    },
                    (error) => {
                        let errorMsg = "Error desconocido al obtener la ubicación.";
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                errorMsg = "Has denegado el permiso de ubicación. Por favor habilítalo para continuar.";
                                break;
                            case error.POSITION_UNAVAILABLE:
                                errorMsg = "La información de ubicación no está disponible.";
                                break;
                            case error.TIMEOUT:
                                errorMsg = "La solicitud de ubicación ha tardado demasiado. Intenta nuevamente.";
                                break;
                        }
                        // 👇 Este alert ya existe y NO se modifica
                        alert(errorMsg);
                        resolve(false);
                    },
                    options
                );
            });
        },

        async Login() {
            try {
                const data = {
                    webuser: this.user,
                    webpw: this.password
                };

                this.$isLoading(true);

                const response = await api.request("post", "/loginFromApp", data);
                console.log('RESPONSE--->', response)
                if ((response.status === 200 && response.data.length > 0) || response.data.login) {
                    if (response.data.login) {
                        const coord1 = response.data.latLng;

                        if (coord1 && coord1 !== "") {
                            const tienePermiso = await this.checkpermisoUbicacion();
                            // alert('permiso-->', tienePermiso)
                            // alert('this.miscoordenadas?', this.misCoordenadas)
                            if (!tienePermiso || !this.misCoordenadas) {
                                this.$isLoading(false);
                                this.$swal("Problemas para obtener tus coordenadas. Por favor habilítalo para continuar.");
                                return;
                            }

                            const [lat1, lon1] = coord1.split(",").map(x => x.trim());
                            const [lat2, lon2] = this.misCoordenadas.split(",").map(x => x.trim());

                            try {
                                this.distancia = await calcularDistancia(lat1, lon1, lat2, lon2);
                                console.log('coord1', coord1)
                                console.log('coord2', this.misCoordenadas)
                                const mts = (this.distancia * 1000).toFixed(2)
                                console.log("Distancia: LN 204 ", mts + ' mts');
                                if (Number(mts) > 200) {
                                    console.log('fuera de rango permitido')
                                    alert(`Distancia: ${mts} mts. Se aplicará reducción de horas.`)
                                    // this.$swal(`Distancia: mts. Se aplicará reducción de horas.`);

                                    const dataQueja = {
                                        subcon: 0,
                                        usuario: this.user.toUpperCase(),
                                        descripcion: `REDUCC. HORAS X FICHAJE DISTANCIA: ${mts} mts.`
                                    };
                                    // COMENTO TEMPORALMENTE
                                    await api.request("post", "/ingresarQuejaYreduccionHoras", dataQueja);
                                }

                                const dataCoordenadas = {
                                    latLng: this.misCoordenadas,
                                    usuario: this.user.toUpperCase(),
                                    distancia: this.distancia.toFixed(2)
                                };
                                await api.request("post", "/guardarCoordenadasbMGES", dataCoordenadas);

                                this.$isLoading(false);
                                this.$swal("Inicio sesión en BMGES");
                            } catch (error) {
                                console.error("Error al calcular distancia:", error);
                                this.$isLoading(false);
                                this.$swal("Error al calcular la distancia. Verifica las coordenadas.");
                            }
                        } else {
                            this.$isLoading(false);
                            this.$swal("Faltan coordenadas en ficha sub.");
                        }
                    } else {
                        this.$isLoading(false);
                        const user = response.data[0];
                        localStorage.setItem("rolUser", 1);
                        localStorage.setItem("usuarioId", user.numero);
                        localStorage.setItem("user", JSON.stringify(user));
                        this.$router.push("/admin/home");
                    }
                } else {
                    this.$isLoading(false);
                    this.$swal("Error, inténtalo nuevamente.");
                }
            } catch (error) {
                this.$isLoading(false);
                console.error(error);
                this.$swal("Error, inténtalo nuevamente.");
            }
        }
    }
};
</script>

<style scoped>
.background {
    background-image: url("../assets/images/background.jpg");
    height: 100vh;
    min-height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
}

.container {
    width: 100%;
}

.user_card {
    height: 400px;
    width: 350px;
    margin-top: 100px;
    margin-bottom: auto;
    background: rgb(255, 255, 255);
    background-image: url("../assets/images/background-02.png");
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 5px;
}

@media (max-width: 768px) {
    .background {
        padding: 20px;
    }

    .user_card {
        background: none;
        background-image: none;
        margin-top: auto;
        margin-bottom: auto;
        width: 100%;
        max-width: 350px;
        height: auto;
        min-height: 400px;
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        border-radius: 0;
    }

    .d-flex.justify-content-center.h-50 {
        height: 100% !important;
        align-items: center;
        width: 100%;
    }
}

.brand_logo_container {
    position: absolute;
    height: 105px;
    width: 170px;
    top: -25px;
    border-radius: 0%;
    background: #19191a;
    padding: 10px;
    text-align: center;
}

.brand_logo {
    height: 85px;
    width: 150px;
    border-radius: 0%;
    border: 2px solid white;
}

.form_container {
    margin-top: 100px;
}

.login_btn {
    width: 100%;
    background: #000000 !important;
    color: white !important;
}

.login_btn:focus {
    box-shadow: none !important;
    outline: 0px !important;
}

.login_container {
    padding: 0 2rem;
}

.input-group-text {
    background: #000000 !important;
    color: white !important;
    border: 0 !important;
    border-radius: 0.25rem 0 0 0.25rem !important;
}

.input_user,
.input_pass:focus {
    box-shadow: none !important;
    outline: 0px !important;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::before {
    background-color: #ffffff !important;
}
</style>